import { Phone, Mail, MapPin } from "lucide-react";
import AtlasLogo from "./AtlasLogo";

const Footer = () => {
  const year = new Date().getFullYear();
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer
      className="relative bg-[#09121C] text-white py-20 md:py-24 border-t border-white/10"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <AtlasLogo variant="light" size="lg" showTagline />
            <p className="mt-6 text-sm text-white/60 leading-relaxed max-w-sm font-light">
              Propreté · Confiance · Excellence. Entretien Net Pro —
              nettoyage commercial et résidentiel.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 border border-[#58BCFA]/40 px-3 py-1.5">
              <span className="w-1.5 h-1.5 bg-[#58BCFA] rounded-full animate-pulse" />
              <span className="text-[12px] uppercase tracking-[0.25em] text-[#58BCFA]">
                Résidentiel & commercial
              </span>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.3em] text-white/40 mb-5">
              Navigation
            </h4>
            <ul className="space-y-3 text-sm">
              {[
                ["services", "Services"],
                ["pourquoi", "Pourquoi nous"],
                ["processus", "Processus"],
                ["faq", "FAQ"],
                ["contact", "Contact"],
              ].map(([id, label]) => (
                <li key={id}>
                  <button
                    onClick={() => scrollTo(id)}
                    data-testid={`footer-link-${id}`}
                    className="link-grow text-white/80 hover:text-[#58BCFA] transition-colors"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs uppercase tracking-[0.3em] text-white/40 mb-5">
              Contact direct
            </h4>
            <ul className="space-y-4 text-sm">
              <li>
                <a
                  href="tel:+14505781383"
                  data-testid="footer-phone-1"
                  className="flex items-center gap-3 text-white hover:text-[#58BCFA] transition-colors"
                >
                  <Phone className="h-4 w-4 text-[#58BCFA]" />
                  450 578 1383
                </a>
              </li>

              <li><a href="tel:+12633552601" className="flex items-center gap-3"><Phone className="h-4 w-4 text-[#58BCFA]"/>263 355 2601</a></li>

              <li><a href="mailto:Entretiennetpro@gmail.com" data-testid="footer-email" className="flex items-center gap-3 hover:text-[#58BCFA] transition-colors"><Mail className="h-4 w-4 text-[#58BCFA] shrink-0"/><span className="break-all">Entretiennetpro@gmail.com</span></a></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            © {year} Entretien Net Pro. Tous droits réservés.
          </p>
          <p className="text-xs text-white/40">
            Nettoyage commercial et résidentiel
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
